<template>
  <v-container class="pa-0" fill-height id="callComplete">
    <v-layout row wrap>
      <v-flex class="fixed-header" offset-sm1 sm10 xs12>
        <v-toolbar color="green" flat>
          <v-tooltip bottom>
            <v-btn
              @click="$router.push({ name: 'activeCall' })"
              icon
              slot="activator"
            >
              <v-icon color="white">arrow_back</v-icon>
            </v-btn>
            <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
          </v-tooltip>
          <v-toolbar-title
            >{{ $vuetify.t('$vuetify.calls.completeCall') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <v-btn dark icon slot="activator">
              <v-icon>apps</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                :to="{ name: 'media', params: { id: callDetail.id } }"
                v-if="
                  callDetail.status != 'Available' &&
                    callDetail.status != 'Accepted'
                "
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.media')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                :to="{ name: 'scans', params: { id: callDetail.id } }"
                v-if="
                  callDetail.status != 'Available' &&
                    callDetail.status != 'Accepted'
                "
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.scans')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                @click="dialogReset = true"
                v-if="callDetail.status != 'Available'"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.resetCall')
                }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-flex>
      <v-flex offset-sm1 sm10 v-if="!isTravelingHomeAtStore" xs12>
        <v-flex px-3 xs12>
          <v-layout align-center mb-3 row>
            <v-flex xs6>
              <span
                :class="
                  !callDetail.visit_status ? 'red--text text--darken-2' : ''
                "
                >{{ $vuetify.t('$vuetify.calls.visitStatus') }} :
                <h2 v-if="callDetail.visit_status">
                  {{ callDetail.visit_status }}
                </h2>
                <h2 v-else>{{ $vuetify.t('$vuetify.app.required') }}</h2>
              </span>
            </v-flex>
            <v-flex class="text-xs-right" xs6>
              <v-btn
                :color="!callDetail.visit_status ? 'red darken-2' : ''"
                @click.native="dialog = true"
                dark
                fab
                id="visitStatusButton"
                v-if="isReady"
              >
                <v-icon large>check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-flex>
        <v-flex mt-3 px-3 xs12>
          <v-layout align-center mb-3 row>
            <v-flex xs6>
              <span :class="!callDetail.travel_started_at ? 'red--text' : ''"
                >{{ $vuetify.t('$vuetify.calls.travelStartTime') }}:</span
              >
              <h2>
                <datetime
                  :max-datetime="now()"
                  format="dd/LL/yyyy HH:mm"
                  placeholder="Select date"
                  ref="travelStartDatetimePicker"
                  type="datetime"
                  v-model="travelStartDatetime"
                ></datetime>
              </h2>
            </v-flex>
            <v-flex class="text-xs-right" xs6>
              <v-btn
                @click.native="openPicker('travelStartDatetimePicker')"
                dark
                fab
                v-if="isReady"
              >
                <v-icon large>access_time</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-flex>
        <v-flex mt-3 px-3 xs12>
          <v-layout align-center mb-3 row>
            <v-flex xs6>
              <span :class="!callDetail.arrived_at ? 'red--text' : ''"
                >{{ $vuetify.t('$vuetify.calls.onSiteTime') }}:</span
              >
              <h2>
                <datetime
                  :min-datetime="minOnSiteDatetime"
                  :max-datetime="maxOnSiteDatetime"
                  format="dd/LL/yyyy HH:mm"
                  placeholder="Select date"
                  ref="onSiteDatetimePicker"
                  type="datetime"
                  v-model="onSiteDatetime"
                ></datetime>
              </h2>
            </v-flex>
            <v-flex class="text-xs-right" xs6>
              <v-btn
                @click.native="openPicker('onSiteDatetimePicker')"
                dark
                fab
                v-if="isReady"
              >
                <v-icon large>access_time</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-flex>
        <v-flex mt-3 px-3 xs12>
          <v-layout align-center mb-3 row>
            <v-flex xs6>
              <span :class="!offSiteDatetime ? 'red--text' : ''"
                >{{ $vuetify.t('$vuetify.calls.offSiteTime') }}:</span
              >
              <h2>
                <datetime
                  :min-datetime="minOffSiteDatetime"
                  :max-datetime="maxOffSiteDatetime"
                  format="dd/LL/yyyy HH:mm"
                  placeholder="Select date"
                  ref="offSiteDatetimePicker"
                  type="datetime"
                  v-model="offSiteDatetime"
                ></datetime>
              </h2>
            </v-flex>
            <v-flex class="text-xs-right" xs6>
              <v-btn
                @click.native="openPicker('offSiteDatetimePicker')"
                dark
                fab
                v-if="isReady"
              >
                <v-icon large>access_time</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-flex>
        <v-form>
          <v-flex mt-3 px-3 xs12>
            <v-textarea
              :error="!this.workDescriptionValue ? true : false"
              :label="$vuetify.t('$vuetify.calls.workCarriedOut')"
              :rules="[rules.required]"
              :value="callDetail.work_description"
              @keyup.native="changeWorkCarriedOut(workDescriptionValue)"
              id="workCarriedOut"
              ref="workCarriedout"
              outline
              v-model="workDescriptionValue"
            ></v-textarea>
          </v-flex>
          <v-flex px-3 xs12>
            <v-text-field
              :error="!this.clientNameValue ? true : false"
              :label="$vuetify.t('$vuetify.calls.clientName')"
              :rules="[rules.required]"
              :value="callDetail.accepted_by_name"
              @input="
                value => {
                  changeClientName(value)
                }
              "
              @keyup.native="changeClientName(clientNameValue)"
              id="clientName"
              outline
              v-model="clientNameValue"
            ></v-text-field>
          </v-flex>
          <v-flex px-3 xs12>
            <v-text-field
              :error="!clientPositionValue ? true : false"
              :label="$vuetify.t('$vuetify.calls.clientPosition')"
              :rules="[rules.required]"
              :value="callDetail.accepted_by_position"
              @input="
                value => {
                  changeClientPosition(value)
                }
              "
              id="clientPosition"
              outline
              v-model="clientPositionValue"
            ></v-text-field>
          </v-flex>

          <v-flex px-3 xs12>
            <h2>Client Satisfaction, how did we do?</h2>
            <div class="text-xs-center sentiment">
              <v-icon
                class="material-icons"
                color="green"
                x-large
                value="Good"
                @click="setSentiment('Good')"
                style="font-size: 6rem"
              >
                sentiment_satisfied
              </v-icon>

              <v-icon
                class="material-icons"
                color="orange"
                x-large
                value="Satisfactory"
                @click="setSentiment('Satisfactory')"
                style="font-size: 6rem"
              >
                sentiment_neutral
              </v-icon>

              <v-icon
                class="material-icons"
                color="red"
                x-large
                value="Below Average"
                @click="setSentiment('Below Average')"
                style="font-size: 6rem"
              >
                sentiment_dissatisfied
              </v-icon>

              <h3>{{ callDetail.sentiment }}</h3>
              <input
                type="hidden"
                class="form-control"
                v-model="sentiment"
                ref="text"
              />
            </div>
            <v-textarea
              v-if="callDetail.sentiment == 'Below Average'"
              solo
              v-model="why_sentiment"
              :value="callDetail.why_sentiment"
              :label="`Please enter a reason why...`"
              @keyup.native="setWhySentiment(why_sentiment)"
            ></v-textarea>
          </v-flex>

          <v-flex px-3 xs12>
            <div v-if="currentSignature">
              Current signature
              <v-img
                :src="
                  currentSignature.url
                    ? currentSignature.url
                    : currentSignature.src
                "
                class="white lighten-2 media"
              >
                <v-layout
                  align-center
                  fill-height
                  justify-center
                  ma-0
                  slot="placeholder"
                >
                  <v-progress-linear
                    color="grey lighten-5"
                    indeterminate
                  ></v-progress-linear>
                </v-layout>
              </v-img>
            </div>
            <signature-pad
              :callId="callId"
              :onlyEvent="true"
              buttonText="Client Signature"
              signatureType="accepted_by_signature"
              title="Sign the Document"
              v-on:signature-updated="signatureUpdated"
            ></signature-pad>
            <v-divider></v-divider>
          </v-flex>
        </v-form>
        <v-layout align-center justify-center row>
          <v-flex md4 sm6 xs6>
            <v-img
              :src="endPhoto.url ? endPhoto.url : endPhoto.base64"
              aspect-ratio="1"
              class="grey lighten-2 media mb-3"
              v-if="
                endPhoto && endPhoto.type == 'image' && endPhotoLoading == false
              "
            >
            </v-img>
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
              v-if="endPhotoLoading == true"
            >
              <v-progress-linear indeterminate color="grey"></v-progress-linear>
            </v-layout>
          </v-flex>
          <v-layout align-center justify-center row>
            <v-flex md6 xs6 mb-2>
              <camera-dialog
                stage="complete"
                v-on:photo-taken="photoTaken"
              ></camera-dialog>
            </v-flex>
            <v-flex md6 xs6 mb-2>
              <v-card color="blue darken-2 mb-3" class="uploadButton btn-file">
                <v-card-text class="white--text text-xs-center">
                  <v-icon x-large color="white">attach_file</v-icon>

                  <div class="title text-xs-center">Upload Photo</div>

                  <input
                    type="file"
                    @change="handleFiles"
                    ref="photoFiles"
                    accept="image/*"
                  />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex
          class="mt-4"
          px-3
          v-if="callDetail.worksheet_required == true && !hasWorksheet"
          xs12
        >
          <v-alert :value="true" type="error">
            Worksheet Required
          </v-alert>
          <v-card
            :class="
              callDetail.status === 'Arrival Completed' ? 'completePanel' : ''
            "
            :to="{ path: '/form/engineer-worksheet' }"
            color="cyan darken-2"
            tile
          >
            <v-card-text class="white--text text-xs-center">
              <v-icon color="white" x-large>book</v-icon>
              <div class="headline text-xs-center">
                {{ $vuetify.t('$vuetify.calls.worksheet') }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="mt-2" px-3 xs12>
          <v-card to="/forms" color="orange darken-1" tile>
            <v-card-text class="white--text text-xs-center">
              <v-icon color="white" x-large>dvr</v-icon>
              <div class="headline text-xs-center">
                Other Forms
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="getCompletedCallForms.length > 0">
          <v-list dense>
            <v-subheader>Completed Forms</v-subheader>
            <v-list-tile v-for="item in getCompletedCallForms" :key="item.slug">
              <v-list-tile-content>
                <v-list-tile-title v-text="item.name"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon color="green">check</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex class="mt-4" px-3 v-if="attachedDocuments == false" xs12>
          <v-alert :value="true" type="error">
            {{ $vuetify.t('$vuetify.calls.noDocumentsAttached') }}
          </v-alert>
        </v-flex>
      </v-flex>
      <v-flex
        class="footer"
        v-if="displayFooter && !isTravelingHomeAtStore"
        xs12
      >
        <v-divider></v-divider>
        <v-btn
          @click.native="timeValidation()"
          block
          class="mt-2"
          color="red"
          dark
          id="completeCallButton"
          large
        >
          {{ $vuetify.t('$vuetify.calls.sendToOffice') }}
        </v-btn>
      </v-flex>
      <v-flex mx-3 offset-sm1 sm10 v-if="isTravelingHomeAtStore" xs12>
        <v-layout align-center mb-3 row>
          <v-flex xs6>
            <span :class="!travelEndDatetime ? 'red--text' : ''"
              >{{ $vuetify.t('$vuetify.calls.travelEndTime') }}:</span
            >
            <h2>
              <datetime
                :max-datetime="now()"
                format="dd/LL/yyyy HH:mm"
                placeholder="Select date"
                ref="travelEndDatetimePicker"
                type="datetime"
                v-model="travelEndDatetime"
              ></datetime>
            </h2>
          </v-flex>
          <v-flex class="text-xs-right" xs6>
            <v-btn
              @click.native="openPicker('travelEndDatetimePicker')"
              dark
              fab
              v-if="isReady"
            >
              <v-icon large>access_time</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-btn
            @click="travelEnd()"
            block
            class="mt-4 mb-3"
            color="red"
            id="travelEndButton"
            large
          >
            {{ $vuetify.t('$vuetify.calls.travelEnd') }}
          </v-btn>
          <v-layout row justify-center mt-3 class="caption">
            or &nbsp;
            <a @click="endtraveldialog = true">{{
              $vuetify.t('$vuetify.calls.cancelTravelHome')
            }}</a>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-dialog v-model="endtraveldialog" max-width="423">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.t('$vuetify.calls.cancelTravelHomeConfirmation')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.t('$vuetify.calls.cancelTravelHomeConfirmationText')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="endtraveldialog = false">
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn color="green darken-1" flat @click="cancelTravelHome()">
            {{ $vuetify.t('$vuetify.calls.yesCancelTravelHome') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog id="visitStatusDialog" v-model="dialog" width="600">
      <v-card>
        <v-card-text class="text-xs-center">
          <p v-html="$vuetify.t('$vuetify.calls.pickPhrase')"></p>
          <v-carousel
            :cycle="false"
            class="carousel elevation-0"
            hide-delimiters
            light
            v-model="statusOptionId"
          >
            <v-carousel-item
              :key="id"
              class="text-xs-center px-5"
              v-for="(option, id) in options"
            >
              <h3>{{ option.message }}</h3>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" flat>
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn
            @click="changeVisitStatus(statusOptionId)"
            color="primary"
            flat
            id="confirmStatusButton"
          >
            {{ $vuetify.t('$vuetify.app.select') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog id="completeDialog" v-model="completeDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $vuetify.t('$vuetify.calls.completeCallHeader') }}
        </v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.calls.completeCallBody') }}
          <v-flex xs12>
            <v-checkbox v-model="isTravelingHome">
              <div slot="label">
                {{ $vuetify.t('$vuetify.calls.travelingHome') }}
              </div>
            </v-checkbox>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="completeDialog = false" color="primary" flat>
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn
            @click.once="completeCall"
            color="primary"
            flat
            id="completeVisitButton"
          >
            {{ $vuetify.t('$vuetify.calls.completeCallConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog id="timeErrorsDialog" v-model="timeErrorsDialog" width="500">
      <v-card>
        <v-card-title class="headline red white--text" primary-title>
          {{ $vuetify.t('$vuetify.calls.checkRequiredFields') }}
        </v-card-title>
        <v-list>
          <template avatar>
            <v-list-tile avatar v-for="error in timeErrors" :key="error">
              <v-list-tile-action>
                <v-icon color="red">warning</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                {{ error }}
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </template>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click=";(timeErrorsDialog = false), (timeErrors = [])"
            color="primary"
            flat
          >
            {{ $vuetify.t('$vuetify.app.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReset" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $vuetify.t('$vuetify.calls.resetCallHeader') }}
        </v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.calls.resetCallBody') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogReset = false" color="primary" flat>
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn @click="confirmReset" color="primary" flat>
            {{ $vuetify.t('$vuetify.calls.resetCallConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title class="headline red white--text" primary-title>
          {{ $vuetify.t('$vuetify.calls.checkRequiredFields') }}
        </v-card-title>
        <v-card-text>
          <v-container pa-1>
            <v-layout row>
              <v-flex shrink>
                <v-icon color="red" x-large>warning</v-icon>
              </v-flex>
              <v-flex pl-3>
                {{
                  $vuetify.t('$vuetify.calls.someOfTheRequiredFieldsAreEmpty')
                }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="errorDialog = false" color="primary" flat>
            {{ $vuetify.t('$vuetify.app.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <proximity-dialog
      :distance-to-site="this.distanceToSite"
      ref="proximityDialog"
      v-on:accept-proximity-warning="confirmProximity"
    ></proximity-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import formatting from '../mixins/formatting.js'
import callActions from '../mixins/callActions.js'
import { Datetime } from 'vue-datetime'
import signaturePad from '@/components/SignaturePad.vue'
import proximityDialog from '@/components/ProximityDialog.vue'
import CameraDialog from '@/components/media/CameraDialog.vue'
import ScansList from '@/components/ScansList.vue'
import MediaList from '@/components/MediaList.vue'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment'

import helpers from '../utils/helpers'
import { constant } from 'lodash-es'

export default {
  name: 'CallComplete',

  mixins: [formatting, callActions],

  components: {
    'proximity-dialog': proximityDialog,
    datetime: Datetime,
    signaturePad,
    CameraDialog,
    ScansList,
    MediaList
  },

  data() {
    return {
      dialog: false,
      endtraveldialog: false,
      dialogReset: false,
      travelStartDatetime: null,
      onSiteDatetime: null,
      minTravelStartDatetime: null,
      maxTravelStartDatetime: null,
      minOnSiteDatetime: null,
      maxOnSiteDatetime: null,
      maxOffSiteDatetime: null,
      minOffSiteDatetime: null,
      minTravelHomeDatetime: null,
      maxTravelHomeDatetime: null,
      offSiteDatetime: null,
      travelEndDatetime: null,
      isTravelingHome: false,
      isTravelingHomeAtStore: false,
      statusOptionId: null,
      completeDialog: false,
      workDescriptionValue: '',
      clientNameValue: '',
      clientPositionValue: '',
      signatureContent: '',
      confirmWorks: true,
      rules: {
        required: value => !!value || 'Required.'
      },
      timeErrors: [],
      timeErrorsDialog: false,
      errorDialog: false,
      datetime: '',
      signature: null,
      sentiment: null,
      why_sentiment: null,
      endPhotoLoading: false,
      isPhoto: null,
      options: [
        {
          id: 0,
          message: 'I have completed all tasks on the order',
          code: 'Job Complete'
        },
        {
          id: 1,
          message:
            'I have completed all tasks on the order, but recommend a quote for a permanent repair',
          code: 'Job Comp/Quote Req'
        },
        {
          id: 2,
          message: 'Aborted visit, as no works are required.',
          code: 'Aborted/Not Req'
        },
        {
          id: 3,
          message:
            "I have completed today's visit, but need to re-attend to complete works on the original order",
          code: 'Vst Comp/Rtn Req'
        },
        {
          id: 4,
          message:
            "I have completed today's visit, but need to reattend with parts when available",
          code: 'Vst Comp/Part Req'
        },
        {
          id: 5,
          message:
            'I have completed all works, but there are items which need to be carried out by a different trade',
          code: 'Vst Comp/New Trd Req'
        },
        {
          id: 6,
          message: 'Aborted visit as no access.',
          code: 'Aborted/No Access'
        },
        {
          id: 7,
          message:
            'I cannot complete the order as the work may be outside the demise of the client',
          code: 'Outside Demise'
        },
        {
          id: 8,
          message:
            'I cannot complete the order due to a H&S (including Asbestos) Incident',
          code: 'Health/Safety'
        }
      ],
      proximityDialog: false,
      endPhoto: null
    }
  },

  mounted() {
    this.readCalls()
    this.getEndPhoto()
    this.populateTravelCompletion()
    if (this.callDetail.status === 'Departed') {
      this.isTravelingHomeAtStore = true
    }
  },

  methods: {
    ...mapActions({
      visitStatus: 'calls/visitStatus',
      travelEndTime: 'calls/travelEndTime',
      travelStartTime: 'calls/travelStartTime',
      travelingHome: 'calls/travelingHome',
      workCarriedOut: 'calls/workCarriedOut',
      offSiteTime: 'calls/offSiteTime',
      onSiteTime: 'calls/onSiteTime',
      clientName: 'calls/clientName',
      clientPosition: 'calls/clientPosition',
      saveSentiment: 'calls/saveSentiment',
      saveWhySentiment: 'calls/saveWhySentiment',
      complete: 'calls/complete',
      readCalls: 'calls/readCalls',
      reset: 'calls/reset',
      checkProximity: 'location',
      addMedia: 'calls/addMedia',
      deleteMedia: 'calls/deleteMedia'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    changeVisitStatus(statusId) {
      this.dialog = false
      const option = this.options.filter(option => option.id === statusId)
      this.visitStatus({ callId: this.callDetail.id, status: option[0].code })
    },

    changeWorkCarriedOut(workCarriedOut) {
      this.workCarriedOut({
        callId: this.callDetail.id,
        work_description: workCarriedOut
      })
    },

    changeClientName(clientName) {
      this.clientName({
        callId: this.callDetail.id,
        accepted_by_name: clientName
      })
    },

    changeClientPosition(clientPosition) {
      this.clientPosition({
        callId: this.callDetail.id,
        accepted_by_position: clientPosition
      })
    },

    async completeCall() {
      const signature = this.currentSignature
      this.completeDialog = false
      let data = this.only(this.callDetail, [
        'work_description',
        'visit_status',
        'accepted_by_name',
        'accepted_by_position',
        'sentiment',
        'why_sentiment'
      ])

      data['extra_data'] = {
        sentiment: this.callDetail.sentiment,
        why_sentiment: this.callDetail.why_sentiment
      }

      data['travel_started_at'] = this.travelStartDatetime
      data['arrived_at'] = this.onSiteDatetime
      data['completed_at'] = this.offSiteDatetime
      data['travel_ended_at'] = this.isTravelingHome
        ? this.travelEndDatetime
        : this.offSiteDatetime

      const maxWidth = process.env.VUE_APP_IMG_MAX_WIDTH
      const maxHeight = process.env.VUE_APP_IMG_MAX_HEIGHT
      const resizedSignature = await helpers.resizeImageFromBase64(
        signature.src,
        maxWidth,
        maxHeight
      )

      data['accepted_by_signature'] = signature ? resizedSignature : null

      data = this.datesToDb(data, [
        'arrived_at',
        'completed_at',
        'travel_started_at',
        'travel_ended_at'
      ])
      if (this.isTravelingHome) {
        this.isTravelingHomeAtStore = true
        this._mDepartCall({ id: this.callDetail.id, data: data })
        this.setNotification(
          this.$vuetify.t('$vuetify.calls.travelToHomeStarted')
        )
        return
      }
      this._mCompleteCall({ id: this.callDetail.id, data: data })
      this.$router.push({ name: 'callsList' })
      this.setNotification(this.$vuetify.t('$vuetify.calls.callCompleted'))
    },

    cancelTravelHome() {
      this.endtraveldialog = false
      this.isTravelingHome = false
      this.isTravelingHomeAtStore = false

      let data = {
        travel_ended_at: this.offSiteDatetime,
        completed_at: this.offSiteDatetime
      }
      data = this.datesToDb(data, ['travel_ended_at', 'completed_at'])
      this._mCompleteCall({ id: this.callDetail.id, data: data })
      this.$router.push({ name: 'callsList' })
      this.setNotification(this.$vuetify.t('$vuetify.calls.callCompleted'))
    },

    travelEnd() {
      if (!this.travelEndDatetime) {
        this.timeErrors.push(
          this.$vuetify.t('$vuetify.calls.confirmTravelEndNotEmpty')
        )
      }
      if (
        moment(this.offSiteDatetime).diff(this.travelEndDatetime, 'minutes') > 0
      ) {
        this.timeErrors.push(
          this.$vuetify.t('$vuetify.calls.offSiteMustBeLessThanTravelEnd')
        )
      }
      if (this.timeErrors.length > 0) {
        this.timeErrorsDialog = true
        return
      }
      let data = {
        travel_ended_at: this.travelEndDatetime,
        completed_at: this.offSiteDatetime
      }
      data = this.datesToDb(data, ['travel_ended_at', 'completed_at'])
      this._mEndTravelCall({ id: this.callDetail.id, data: data })
      this.$router.push({ name: 'callsList' })
      this.setNotification(this.$vuetify.t('$vuetify.calls.callCompleted'))
    },

    openPicker(picker) {
      this.$refs[picker].$el.children[0].click()
    },
    confirmReset() {
      this.dialogReset = false
      this.reset(this.callDetail.id)
        .then(response => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callReset'))
          if (!this.activeCallId) {
            this.$router.push('/calls')
          }
        })
        .catch(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotReseted'))
        })
    },

    signatureUpdated(p) {
      this.signature = p
    },

    checkProximity() {
      if (this.distanceToSite > process.env.VUE_APP_PROXIMITY) {
        this.$refs.proximityDialog.show()
      } else {
        this.completeDialog = true
      }
    },

    confirmProximity() {
      this.$refs.proximityDialog.hide()
      this.completeDialog = true
    },

    timeValidation() {
      if (
        this.isReady &&
        this.clientPositionValue &&
        this.clientNameValue &&
        this.workDescriptionValue &&
        this.workDescriptionValue.length > 5 &&
        this.offSiteDatetime &&
        this.callDetail.arrived_at &&
        this.callDetail.travel_started_at &&
        this.callDetail.visit_status &&
        this.currentSignature &&
        (this.hasWorksheet || this.callDetail.worksheet_required == false) &&
        this.endPhoto &&
        this.confirmWorks
      ) {
        if (
          moment(this.travelStartDatetime).diff(
            this.onSiteDatetime,
            'minutes'
          ) > 0
        ) {
          this.timeErrors.push(
            this.$vuetify.t('$vuetify.calls.travelStartMustBeLessThanOnSite')
          )
        }
        if (
          moment(this.onSiteDatetime).diff(this.offSiteDatetime, 'minutes') > 0
        ) {
          this.timeErrors.push(
            this.$vuetify.t('$vuetify.calls.onSiteMustBeLessThanOffSite')
          )
        }
        if (
          moment(this.offSiteDatetime).diff(this.travelEndDatetime, 'minutes') >
          0
        ) {
          this.timeErrors.push(
            this.$vuetify.t('$vuetify.calls.offSiteMustBeLessThanTravelEnd')
          )
        }
        this.timeErrors = [...new Set(this.timeErrors)]
        if (this.timeErrors.length > 0) {
          this.timeErrorsDialog = true
        } else {
          this.checkProximity()
        }
      } else {
        if (!this.callDetail.visit_status) {
          this.timeErrors.push('Please select a visit status')
        }
        if (!this.callDetail.work_description) {
          this.timeErrors.push('Please fill out a work description')
        }
        if (
          this.callDetail.work_description &&
          this.callDetail.work_description.length <= 5
        ) {
          this.timeErrors.push(
            'Work description must be more than 5 characters'
          )
        }
        if (!this.clientNameValue) {
          this.timeErrors.push('Please fill out a client name')
        }
        if (!this.offSiteDatetime) {
          this.timeErrors.push('Please fill in an off site time')
        }
        if (!this.clientPositionValue) {
          this.timeErrors.push('Please fill out a client position')
        }
        if (!this.currentSignature) {
          this.timeErrors.push('Please provide a signature')
        }
        if (!this.callDetail.sentiment) {
          this.timeErrors.push(
            'Please tell us how the client felt about the visit'
          )
        }
        if (!this.endPhoto) {
          //this.setNotification(this.$vuetify.t('$vuetify.calls.mustTakeEndPhoto'))
          this.timeErrors.push(
            this.$vuetify.t('$vuetify.calls.mustTakeEndPhoto')
          )
        }
        if (!this.hasWorksheet && this.callDetail.worksheet_required == true) {
          this.timeErrors.push('You must fill out a worksheet')
        }
        this.timeErrors = [...new Set(this.timeErrors)]
        this.timeErrorsDialog = true
      }
    },

    getEndPhoto() {
      const media = _.find(this.callDetail.media, function(obj) {
        return obj.custom_properties.stage == 'complete'
      })
      this.endPhoto = media
      return media
    },

    photoTaken(media) {
      this.endPhoto = media
      this.isPhoto = true
      this.endPhotoLoading = false
    },

    handleFiles() {
      this.endPhotoLoading = true
      const callId = this.activeCallId
      this.files = this.$refs.photoFiles.files
      this.getEndPhoto()
      const _this = this
      Array.from(this.files).forEach(file => {
        const maxWidth = process.env.VUE_APP_IMG_MAX_WIDTH
        const maxHeight = process.env.VUE_APP_IMG_MAX_HEIGHT
        helpers.resizeImage(file, maxWidth, maxHeight).then(res => {
          const media = {}
          media.src = res
          media.url = res
          media.name = file.name
          media.type = 'image'
          media.stage = 'complete'
          media.collection_name = 'media'
          media.model_id = _this.endPhoto ? _this.endPhoto.model_id : callId
          if (_this.endPhoto) {
            media.id = _this.endPhoto.id
            _this.deleteMedia(_this.endPhoto).then(() => {
              _this
                .addMedia({ id: callId, media: media })
                .then(res => {
                  _this.$refs.photoFiles.value = null
                  _this.endPhoto = media
                  _this.endPhoto.id = res.data.data.id
                  _this.endPhotoLoading = false
                })
                .catch(e => {
                  _this.$refs.photoFiles.value = null
                  console.log(e, 'error')
                })
            })
          } else {
            _this
              .addMedia({ id: callId, media: media })
              .then(res => {
                _this.$refs.photoFiles.value = null
                _this.endPhoto = media
                _this.endPhoto.id = res.data.data.id
                _this.endPhotoLoading = false
              })
              .catch(e => {
                _this.$refs.photoFiles.value = null
                console.log(e, 'error')
              })
          }
        })
      })
    },

    populateTravelCompletion() {
      if (this.callDetail.travel_started_at) {
        this.travelStartDatetime = this.callDetail.travel_started_at
      }
      if (this.callDetail.arrived_at) {
        this.onSiteDatetime = this.callDetail.arrived_at
      }
      if (this.callDetail.completed_at) {
        this.offSiteDatetime = this.callDetail.completed_at
      } else {
        this.offSiteDatetime = null
      }
      if (this.callDetail.work_description) {
        this.workDescriptionValue = this.callDetail.work_description
      }
      if (this.callDetail.accepted_by_name) {
        this.clientNameValue = this.callDetail.accepted_by_name
      }
      if (this.callDetail.accepted_by_position) {
        this.clientPositionValue = this.callDetail.accepted_by_position
      }
    },
    setSentiment(sentiment) {
      this.saveSentiment({
        callId: this.callDetail.id,
        sentiment: sentiment
      })
      this.sentiment = this.callDetail.sentiment
    },
    setWhySentiment(why_sentiment) {
      this.saveWhySentiment({
        callId: this.callDetail.id,
        why_sentiment: why_sentiment
      })
      this.why_sentiment = this.callDetail.why_sentiment
    }
  },
  computed: {
    ...mapState({
      calls: state => state.calls.list,
      distanceToSite: state =>
        state.location.distanceToSite ? state.location.distanceToSite.value : 0
    }),
    ...mapGetters({
      getCallById: 'calls/getCallById',
      getSignature: 'calls/getSignature',
      getSignatureByType: 'calls/getSignatureByType',
      activeCallId: 'calls/activeCallId',
      hasWorksheet: 'calls/hasWorksheet',
      getFormData: 'calls/getFormData',
      getCompletedCallForms: 'calls/getCompletedCallForms'
      // callDetail: 'calls/getActiveCall'
    }),

    isReady() {
      return (
        this.callDetail.status === 'Arrival Completed' ||
        (this.callDetail.visit_status === 'Job Complete' &&
          !this.callDetail.travel_ended_at) ||
        !this.isTravelingHomeAtStore
      ) /* || this.callDetail.status === 'Arrived'*/
    },

    callId() {
      return this.$route.params.id
    },

    callDetail() {
      const callDetail = this.getCallById(this.$route.params.id)
      return callDetail
    },

    currentSignature() {
      const s = this.getSignatureByType(
        this.callDetail.id,
        'accepted_by_signature'
      )
      return this.signature || s
    },

    attachedDocuments() {
      return !!(
        this.callDetail &&
        this.callDetail.scans &&
        this.callDetail.scans.length > 0
      )
    },

    displayFooter() {
      return this.isReady
    }
  },
  watch: {
    isTravelingHome: function(value) {
      if (value)
        this.travelingHome({ callId: this.callDetail.id, travelingHome: value })
    },
    offSiteDatetime: function(value) {
      this.offSiteDatetime = moment(value)
        .tz('Europe/London')
        .format()
      this.maxTravelHomeDatetime = moment(this.travelStartDatetime)
        .add(1439, 'minutes')
        .toISOString()
      this.minTravelHomeDatetime = moment(this.offSiteDatetime).toISOString()
      if (moment(this.maxTravelHomeDatetime).isAfter(moment())) {
        this.maxTravelHomeDatetime = moment().toISOString()
      }
    },
    travelStartDatetime: function(value) {
      this.travelStartDatetime = moment(value)
        .tz('Europe/London')
        .format()
      this.maxOnSiteDatetime = moment(this.travelStartDatetime)
        .add(1439, 'minutes')
        .toISOString()
      this.minOnSiteDatetime = moment(this.travelStartDatetime).toISOString()
      if (moment(this.onSiteDatetime).isAfter(this.maxOnSiteDatetime)) {
        this.onSiteDatetime = null
      }
      if (moment(this.maxOnSiteDatetime).isAfter(moment())) {
        this.maxOnSiteDatetime = moment().toISOString()
      }
    },
    onSiteDatetime: function(value) {
      this.onSiteDatetime = moment(value)
        .tz('Europe/London')
        .format()
      this.maxOffSiteDatetime = moment(this.travelStartDatetime)
        .add(1439, 'minutes')
        .toISOString()
      this.minOffSiteDatetime = moment(this.onSiteDatetime).toISOString()
      if (moment(this.offSiteDatetime).isAfter(this.maxOnSiteDatetime)) {
        this.offSiteDatetime = null
      }
      if (moment(this.maxOffSiteDatetime).isAfter(moment())) {
        this.maxOffSiteDatetime = moment().toISOString()
      }
    },
    callDetail: function(newVal) {
      if (this.callDetail) {
        this.populateTravelCompletion()
      }
      this.travelStartDatetime = newVal.travel_started_at
      this.onSiteDatetime = newVal.arrived_at
      this.offSiteDatetime = newVal.completed_at || this.now()
      // this.travelEndDatetime = this.offSiteDatetime
      this.isTravelingHome = newVal.travelingHome
      this.isTravelingHomeAtStore = newVal.status === 'Departed'
      this.workDescriptionValue = newVal.work_description
      this.clientNameValue = newVal.accepted_by_name
      this.clientPositionValue = newVal.accepted_by_position
    }
  }
}
</script>

<style scoped lang="scss">
.carousel {
  height: 200px !important;

  h3 {
    font-size: 20px;
    line-height: 1.2em;
    margin: 0 20px;
  }
}

.vdatetime-input {
  display: none;
}

.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}

.uploadButton {
  cursor: pointer;
}
.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  opacity: 0;
  outline: none;
  background: #fff;
  cursor: inherit;
  display: block;
}
</style>
